import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { Observable } from "rxjs/Observable";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { ComboService, CommonService, SampleService, StockService } from "../../../services/index";
import * as fromCommonStore from "../../../store";
import * as commonActions from "../../../store/actions/common.actions";
import { SamplePrint } from "./samplePrint";
import * as $ from "jquery";


@Component({
  selector: "invoice-tab",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./dStock.html",
})
export class dStock implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  // @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  isLoadMask: Promise<any>;
  invoiceData: any[];
  dStockData: any = [];
  // matchList: any;
  data: any;
  sampleList: any;
  shadelist = [];
  barcodeData = [];
  printCount: any;
  box : boolean;
  shirt : boolean;
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  gridOptions: any;
  partyCtrl: FormControl = new FormControl();
  partyList$ = [];
  styleData: any;
  partyList: Observable<any[]>;
  fabricList: any[];
  verifier: string;
  reason: string;
  combo_id: any;

  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "inw_id",
    orderDir: "desc",
  };

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("printTemplate") printTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("stickerTemplate") stickerTemplate: TemplateRef<any>;

  columns = [];
  toggleCol = [];
  sampleCancelReasonList = [];
  // typeList = ["SWATCH", "WAREHOUSE", "SWATCH & WAREHOUSE"];
  // styleList = ["FORMAL", "CASUAL", "STYLISH FORMAL", "CLUB WEAR"];
  // brandList = ["EXPOSE", "ARAZA", "GREEN OLIVE", "LEO BOYS", "JOB"];

  filterExpand = false;

  filter = {
    season_name: "",
    shirt_no: "",
    dhoti_no: "",
    combo_name: ""
  };

  // partyStoreSub;
  // itemStoreSub;
  // invoiceStoreSub;
  seasonList = [];
  // printConfig: any = {
  //   title: "Sales Invoice",
  //   columns: [],
  //   rows: [],
  // };
  companyInfo: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private sampService: SampleService,
    public datePipe: DatePipe,
    private modalService: BsModalService,
    public toasterService: ToasterService,
    private commonService: CommonService,
    private comboservice: ComboService,
    private stockService : StockService
  ) {
    /*   this.companyInfo = JSON.parse(localStorage.getItem('companyInfo'));
           this.filterData.company_id = this.companyInfo.id;
           */
    // this.invoiceStoreSub = this.store
    //   .select(fromRootStore.getLoadInvoice)
    //   .subscribe((isLoad: any) => {
    //     if (isLoad) {
    //       this.getSampleList();
    //     }
    //   });

    // this.partyStoreSub = this.store
    //   .select(fromCommonStore.getAllParty)
    //   .subscribe((res: any) => {
    //     if (_.isEmpty(res)) {
    //       return;
    //     }
    //     this.partyList$ = res.data;
    //   });

    /*  this.partyList = this.partyCtrl.valueChanges
              .startWith(null)
              .map(name => name ? this.filterItems(name, 'Party') : this.partyList$.slice());*/
  }

  ngOnInit(): void {
    $("#entry_div").hide();
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
        height: 20,
        cellClass: "text-center",
        sortable: false,
        headerClass: "text-center",
        cellTemplate: this.snoTemplate,
        toggle: true,
        isPrint: false,
      },
      {
        name: "Season",
        prop: "season",
        minWidth: 200,
        maxWidth: 200,
        width: 200,
        height: 20,
        cellClass: "text-center",
        sortable: false,
        headerClass: "text-center",
      },
      {
        name: "Ref.No",
        prop: "ref_no",
        minWidth: 50,
        maxWidth: 100,
        width: 50,
        height: 20,
        cellClass: "text-center",
        sortable: false,
        headerClass: "text-center",
      },
      {
        name: "Ref.Date",
        prop: "ref_date",
        minWidth: 50,
        maxWidth: 200,
        width: 50,
        height: 20,
        cellClass: "text-center",
        sortable: false,
        headerClass: "text-center",
      },
      {
        name: "Shirt No",
        prop: "shirt_no",
        height: 20,
        minWidth: 200,
        maxWidth: 200,
        width: 200,
        headerClass: "text-center",
        cellClass: "text-center",
        align: "right",
        type: "number",
      },
      {
        name: "Dhoti_no",
        prop: "dhoti_no",
        height: 20,
        minWidth: 200,
        maxWidth: 200,
        width: 200,
        headerClass: "text-center",
        cellClass: "text-center",
        sortable: false,
      },
      {
        name: "Combo Name",
        prop: "combo_name",
        height: 20,
        minWidth: 200,
        maxWidth: 200,
        width: 50,
        headerClass: "text-center",
        cellClass: "text-center",
        sortable: false,
      },
      {
        name: "Total Pcs",
        prop: "tot_pcs",
        height: 20,
        minWidth: 50,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
        cellClass: "text-right",
        sortable: false,
      },
      {
        name: "Action",
        prop: "action",
        height: 20,
        minWidth: 50,
        maxWidth: 100,
        width: 50,
        sortable: false,
        headerClass: "text-center",
        cellClass: "text-center",
        cellTemplate: this.editDeleteTemplate,
        isPrint: false,
      },
      {
        name: "Barcode",
        prop: "print",
        height: 20,
        minWidth: 50,
        maxWidth: 100,
        width: 50,
        sortable: false,
        headerClass: "text-center",
        cellClass: "text-center",
        cellTemplate: this.printTemplate,
        isPrint: false,
      },
    ];

    this.toggleCol = Object.assign({}, this.columns);
    // this.data = this.commonService.itemMaster();
    //   this.getFabDesigns();
    this.getSeasonList();
    // this.getCancelReasonList();
    this.pageCallback({ offset: 0 });
    //   this.sampledata.season = this.invoiceData[0].season;
  }


  hotkeys(event) {
    if (this.active) {
      if (event.altKey && event.keyCode === 65) {
        //          this.addEditInvoice('Add', '');
      }
      if (event.keyCode === 27) {
        //  this.bsModalRef.hide();
      }
    }
  }

  onChangePageSize(limit) {
    this.page.limit = limit;
    this.getSampleList();
  }

  getSeasonList() {
    let params = {
      date: new Date().getFullYear(),
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getSeason(params).then((res: any) => {
      let partialSeason = [];
      for (let i = res.length - 1; i > res.length - 11; i--) {
        partialSeason.push(res[i]);
      }

      this.seasonList = partialSeason;
    });
  }

  // getCancelReasonList() {
  //   let params = {};
  //   this.sampService.getCancelReasonList(params).then((res: any) => {

  //     this.sampleCancelReasonList = res.data;
  //   });
  // }

  showFilter() {
    $("#entry_div").hide(1000);
    $("#filter_div").show(1000);
  }

  showEntry() {
    $("#filter_div").hide(1000);
    $("#entry_div").show(1000);
  }

  editSampleInward(row) {
    $("#filter_div").hide(1000);
    $("#entry_div").show(1000);
  }

  onEnterKeyPressed(nextEl: string) {
    setTimeout(() => {
      $("#" + nextEl).focus();
    }, 100);
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getSampleList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getSampleList();
  }

  getSampleList(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter),
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllInvoice(params));
    this.isLoadMask = this.sampService
      .getComboStockList(params)
      .then(function (res: any) {
        if (res.success) {
          that.loadingIndicator = false;
          that.page.count = res.totCnt;
          that.dStockData = res.data;
        }
      });
  }

  deleteDhotiSample(row) {
    let that = this;
    swal({
      title: "Are you sure to delete this Dhoti Sample?",
      text: "You will not be able to recover this Dhoti Sample",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(
      function () {
        const params = {
          combo_id: row.combo_id,
          combo_name: row.combo_name
        }

        that.sampService.deleteDhotiSample(params).then((res: any) => {
          if (res.success) {
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: "Dhoti sample deleted successfully",
            });
            that.getSampleList();
          }
        });
      },
      function (dismiss) { }
    );
  }


  clearFilter() {
    this.filter.season_name = "";
    this.filter.shirt_no = "";
    this.filter.dhoti_no = "";
    this.filter.combo_name = "";
    this.applyFilter();
  }

  applyFilter() {
    this.getSampleList();
  }

  displayFn(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Party") {
      list = this.partyList$;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { party_id: id });
      return fitem["party_name"];
    }
    return "";
  }

  gotoAddEditDStock(mode: string, row: any): void {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getSampleList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {
      tabObj = {
        action: "NewTab",
        params: {
          tabParent: "WAREHOUSE",
          tabName: "ADD D STOCK",
          id: "AddEditDStock",
          name: "ADD D STOCK",
          mode: mode,
          data: row,
        },
      };
    } else if (mode == "Edit") {
      tabObj = {
        action: "NewTab",
        params: {
          tabParent: "WAREHOUSE",
          tabName: "EDIT D STOCK",
          id: "AddEditDStock",
          name: "EDIT D STOCK",
          mode: mode,
          data: row,
        },
      };
    }

    this.tabUpdateEvent.emit(tabObj);
  }

  // @ViewChild("printPage") printPage;
  // onPrintInvoice(row) {
  //   this.printConfig = {
  //     type: "invoice",
  //     title: "Sales Invoice",
  //     rows: row,
  //   };

  //   setTimeout(() => {
  //     this.printPage.printPreview();
  //   }, 100);
  // }

  // getStyleDetails(row) {
  //   let params = {
  //     style_no: row.style_no,
  //   };
  //   this.sampService.getStyleDetails(params).then((res: any) => {
  //     this.styleData = res.data;
  //     this.printSample("Print", row);
  //     //  this.loadeditsamplelist(row);
  //   });
  // }

  // bsModalRef: BsModalRef;
  // printSample(mode: string, row: any): void {
  //   let that = this;
  //   setTimeout(function () {
  //     that.filterPanel.close();
  //   }, 10);

  //   this.bsModalRef = this.modalService.show(SamplePrint, {
  //     keyboard: false,
  //     ignoreBackdropClick: true,
  //     class: "modal-lg compWidth-96",
  //   });
  //   this.bsModalRef.content.title = mode + this.title + "Details";
  //   this.bsModalRef.content.mode = mode;
  //   this.bsModalRef.content.sampledata = Object.assign({}, row);
  //   this.bsModalRef.content.styledata = Object.assign({}, this.styleData);
  //   // this.bsModalRef.content.matchlist = this.matchList;
  //   (this.bsModalRef.content.tabID = this.tabID),
  //     (this.bsModalRef.content.tabTitle = this.title),
  //     this.bsModalRef.content.partyUpdateEvent.subscribe(($e) => {
  //       if (this.title == "DesignStockComponent")
  //         this.store.dispatch(new commonActions.LoadAllParty());
  //       else this.store.dispatch(new commonActions.LoadAllCompany());
  //     });
  // }

  // loadeditsamplelist(row) {
  //   let params = {
  //     samp_id: row.samp_id,
  //   };
  //   this.sampService.getEditSampleList(params).then((res: any) => {
  //     this.shadeList(row);

  //     this.sampleList = res.data;
  //   });
  // }

  // shadeList(row) {
  //   // let coloList = row.sample_color;
  //   let sample_no = row.sample_no;
  //   let params = {
  //     sample_no: sample_no,
  //   };

  //   this.sampService.getShadeList(params).then((res: any) => {
  //     let data1: any = res.data;

  //     for (var i = 0; i < data1.length; i++) {
  //       for (var key in data1[i]) {
  //         let temp = data1[i][key];
  //         this.shadelist.push(temp);
  //       }
  //     }
  //     this.clickPrint(row, this.shadelist);
  //     console.log(res);
  //   });
  // }

  // clickPrint(row, data) {
  //   let that = this;
  //   let params: any = Object.assign({}, row);
  //   params["data"] = JSON.stringify(data);
  //   that.isLoadMask = that.sampService
  //     .sampleSticker(params)
  //     .then(function (res: any) { });
  // }

  // ngOnDestroy() {
  //   // this.partyStoreSub.unsubscribe();
  //   // this.invoiceStoreSub.unsubscribe();
  // }

  loadPrintData(row: any) {
    const params = {
      inw_id: row.inw_id
    };

    this.sampService.getComboBarcodes(params).then((res: any) => {
      if (res.data.length > 0) {
         this.barcodeData = res.data;
         $("#printpr").show();
      } else {
        swal("Error", "Barcode Not Exist!", "error");
      }
    });
  }

  print() {
    if ($("#box").is(":checked")) {
      this.box = true;
    } else {
      this.box = false;
    }
    if ($("#shirt").is(":checked")) {
      this.shirt = true;
    } else {
      this.shirt = false;
    }

    $("#box").prop("checked", false);
    $("#shirt").prop("checked", false);

    let params = {
      noofpcs: 1,
      export: false,
      box: this.box,
      shirt: this.shirt,
      designdet: JSON.stringify(this.barcodeData),
    };
    $("#printpr").hide();
    this.stockService.print(params).then((res: any) => {
      this.barcodeData = [];
    });
  }
    closed(): void {
    $("#printpr").hide();
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/sample/dStock.ts